import React, { Component } from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'
import { MdClose } from 'react-icons/lib/md'
import Logo from '../Accessories/Logo'

const iconStyle = {
  width: '40px',
  height: '40px',
  color: 'black',
  background: 'white',
  border: '1px solid black',
  margin: '5px 0 0 5px',
  padding: '10px',
  borderRadius: '50%'
}

class MobileMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      isVisClass: 'hidden'
    }
  }

  show() {
    if (!this.state.visible) {
      this.setState({ isVisClass: 'visible', visible: true })
    } else {
      this.setState({ isVisClass: 'hidden', visible: false })
    }
  }

  render() {
    return (
      <MobileMenuContainer id="mobile-menu" className={this.state.isVisClass}>
        <div className={'menu-grid'}>
          <button onClick={() => this.show()}>
            <MdClose style={iconStyle} />
          </button>
          <ul>
            <li>
              <Link to={'/'} onClick={() => this.show()}>
                Home
              </Link>
            </li>
            <li>
              <Link to={'/pricing'} onClick={() => this.show()}>
                Pricing
              </Link>
            </li>
            <li>
              <Link to={'/blog'} onClick={() => this.show()}>
                Blog
              </Link>
            </li>
            <li>
              <Link to={'/customers'} onClick={() => this.show()}>
                Customers
              </Link>
            </li>
            <li>
              <Link to={'/contact'} onClick={() => this.show()}>
                Contact Us
              </Link>
            </li>
          </ul>
          <div className="logo">
            <Logo />
          </div>
        </div>
      </MobileMenuContainer>
    )
  }
}

export default MobileMenu

const MobileMenuContainer = styled.div`
  &.visible {
    left: 0;
  }

  &.hidden {
    left: -500px;
  }

  width: 250px;
  height: 2000px;
  background: white;
  box-shadow: 10px 0px 20px 0px rgba(71, 71, 71, 0.25);
  z-index: 2;
  position: fixed;
  top: 0;
  left: 0;
  transition: 400ms ease all;

  .menu-grid {
    height: 100vh;
    display: grid;
    grid-auto-rows: 100px 1fr 200px;

    & button {
      width: 100px;
      border: none;
      background: transparent;
    }
  }

  & ul {
    padding: 10px;
  }
  & li {
    padding: 20px;
    display: flex;
  }
  & li a {
    font-size: 2rem;
  }

  .logo {
    justify-self: center;
  }
`



// WEBPACK FOOTER //
// ./src/components/Layout/MobileMenu.jsx